import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Compliance = () => <PublicStaticPage pageKey="compliance" />;

export default Compliance;
